// Dependencies
import { FC, MouseEventHandler } from "react";

// Components
import { Typography } from "@mui/material";
import TransactionAmount from "../TransactionAmount";
// utils
import { currencyFormat } from "~/utils";

// Styles
import {
  StyledItemInfo,
  StyledItemWrapper,
  StyledItemCategory,
  StyledCategoryIcon,
} from "./TransactionItem.styled";
import { DefaultCategory } from "~/enums";

interface TransactionItemProps {
  categoryName: string;
  categoryID: string;
  note: string;
  username: string;
  amount: string;
  sign: -1 | 1;
  walletCurrency: string;
  onClick: MouseEventHandler;
}

const TransactionItem: FC<TransactionItemProps> = ({
  categoryName,
  categoryID,
  note,
  username,
  amount,
  sign,
  walletCurrency,
  onClick,
}) => {
  return (
    <StyledItemWrapper onClick={onClick}>
      <StyledCategoryIcon src={DefaultCategory[categoryID]?.icon} />
      <StyledItemInfo>
        <StyledItemCategory>
          <Typography variant={"h3"}>{categoryName}</Typography>
          <Typography variant={"h4"}>{username}</Typography>
        </StyledItemCategory>
        <StyledItemCategory>
          <Typography variant={"h4"}>{note}</Typography>
          <TransactionAmount sign={sign} variant={"h3"}>
            {currencyFormat(amount, walletCurrency)}
          </TransactionAmount>
        </StyledItemCategory>
      </StyledItemInfo>
    </StyledItemWrapper>
  );
};

export default TransactionItem;
